import { render, staticRenderFns } from "./HeaderTranslations.vue?vue&type=template&id=72d96a77&"
import script from "./HeaderTranslations.vue?vue&type=script&lang=js&"
export * from "./HeaderTranslations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports